// CDR runtime config. CDR lives in AWS account 003508526255, us-east-1.
// Resource IDs sourced from the provisioned CDR stack (user pool + identity
// pool cdr-doc-analyzer, API cdr-DocProcessApi/prod, app client cognito-client).
// Canonical portal domain is https://portal.cdr.vg.us.spsglobal.com (the only
// host that resolves); the Cognito app client callback/logout URLs must match it.
const Config = {
  StackName: "cdr-doc-analyzer",
  DefaultImageName: "default_document_3.png",
  CognitoIdentityPoolId: "us-east-1:2fbd0902-98dc-4a71-becd-72fb0101589b",
  CognitoUserPoolId: "us-east-1_41XbPAySb",
  DeployRegion: "us-east-1",
  CognitoId: "cognito-idp.us-east-1.amazonaws.com/us-east-1_41XbPAySb",
  APIUrl: "https://1grqfbeea8.execute-api.us-east-1.amazonaws.com/prod",
  LogoutUrl:
    "https://cdr-vanguard-platform-cdr.auth.us-east-1.amazoncognito.com/logout?client_id=4l5h7e01f4vldht1a2o8mfc2vc&logout_uri=https://portal.cdr.vg.us.spsglobal.com&redirect_uri=https://portal.cdr.vg.us.spsglobal.com&response_type=token",
  LoginUrl:
    "https://cdr-vanguard-platform-cdr.auth.us-east-1.amazoncognito.com/login?client_id=4l5h7e01f4vldht1a2o8mfc2vc&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.cdr.vg.us.spsglobal.com",
  ChatExternalLink: "https://www.google.com",
  TicketExternalLink: null,
  AnalyticsExternalLink: "https://reports.cdr.vg.us.spsglobal.com/",
  OperatorHubExternalLink: "/operator-hub/",
  TicketTableColumns: {
    ticket: { visible: true },
    title: { visible: true },
    subject: { visible: true },
    status: { visible: true },
    docClass: { visible: true },
    lob: { visible: true },
    created: { visible: true },
    checkNumber: { visible: false, hideIfEmpty: true },
    checkType: { visible: false, hideIfEmpty: true },
    checkAmount: { visible: false, hideIfEmpty: true },
    comments: { visible: true },
    view: { visible: true },
    action: { visible: true },
  },
};

export default Config;
